import { normalizeRole } from '@/utils/normalize-role';
import type { Admin, RoleType } from '@/types/auth';

/**
 * Resolve the caller's role in the selected workspace, falling back to the first workspace
 * (mirroring how the app store defaults `selectedWholesalerId`). Returns null when the
 * backend role string isn't one we recognise — client-side gating is UX-only, so callers
 * decide how strictly to treat unknown roles; the server enforces the real rules.
 */
export const getWorkspaceRole = (
  user: Admin | null,
  selectedWholesalerId: string | null,
): RoleType | null => {
  const workspace =
    user?.wholesalers.find((wholesaler) => wholesaler.id === selectedWholesalerId) ??
    user?.wholesalers[0] ??
    null;

  return normalizeRole(workspace?.role);
};
